import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';
import Plans from '../../models/plans.json';
import Languages from '../../models/languages.json';
import Mockups from '../../models/mockups.json';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  plans: any = Plans;
  languages: any = Languages;
  mockups: any = Mockups;
  mockupsResponsiveOptions = [{ breakpoint: '767px', numVisible: 1, numScroll: 1 }];
  selectedLanguage: any;
  faqs = [
    {
      id: 1,
      question: 'faq-question-1',
      answer: 'faq-answer-1',
      open: false,
    },
    {
      id: 2,
      question: 'faq-question-2',
      answer: 'faq-answer-2',
      open: false,
    },
    {
      id: 3,
      question: 'faq-question-3',
      answer: 'faq-answer-3',
      open: false,
    },
    {
      id: 4,
      question: 'faq-question-4',
      answer: 'faq-answer-4',
      open: false,
    },
    {
      id: 5,
      question: 'faq-question-5',
      answer: 'faq-answer-5',
      open: false,
    },
    {
      id: 6,
      question: 'faq-question-6',
      answer: 'faq-answer-6',
      open: false,
    },
  ];
  fullname = '';
  email = '';
  subject = '';
  message = '';
  isError = false;
  isErrorText = 'form-is-not-valid';
  menuOpen = false;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private translateService: TranslateService,
  ) {}

  ngOnInit() {
    const width = window.innerWidth;
    if (width >= 768) {
      this.menuOpen = true;
    }
    this.isError = false;
    this.isErrorText = 'form-is-not-valid';
    const currentLang = localStorage.getItem('language') || 'en';
    this.selectedLanguage = this.languages.find(
      (lang) => lang.id === currentLang,
    );
  }

  setFullname(event: any) {
    this.fullname = event.target.value;
  }

  setEmail(event: any) {
    this.email = event.target.value;
  }

  setSubject(event: any) {
    this.subject = event.target.value;
  }

  setMessage(event: any) {
    this.message = event.target.value;
  }

  setLanguage(event: any) {
    this.selectedLanguage = event.value;
    localStorage.setItem('language', event.value.id);
    this.translateService.use(event.value.id);
  }

  sendContactForm() {
    this.isError = false;
    this.isErrorText = 'form-is-not-valid';

    if (
      this.fullname.trim() === '' ||
      this.subject.trim() === '' ||
      this.message.trim() === ''
    ) {
      this.isError = true;
      this.isErrorText = 'form-is-not-valid';
      return;
    }
    if (!this.authenticationService.validateEmail(this.email)) {
      this.isError = true;
      this.isErrorText = 'email-is-not-valid';
      return;
    }

    const teveniEmail = environment.teveniEmail;

    const encodedSubject = encodeURIComponent(this.subject);
    const encodedBody = encodeURIComponent(this.message);
    const mailtoLink = `mailto:${teveniEmail}?subject=${encodedSubject}&body=${encodedBody}`;
    window.location.href = mailtoLink;
  }

  openFaq(faq) {
    faq.open = !faq.open;
  }

  triggerMenu() {
    this.menuOpen = !this.menuOpen;
  }

  scrollToSection(section) {
    const targetElement = document.getElementById(section);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
    }
    if (window.innerWidth < 768) {
      this.menuOpen = false;
    }
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }

  goToRegister() {
    this.router.navigate(['/register']);
  }

  goToDiscover() {
    this.router.navigate(['/discover']);
  }

  goToDelivery() {
    window.open(environment.deliveryUrl, '_blank');
  }

  goToRegisterWithPlan(planId) {
    // set service plan variable to selected plan
    this.router.navigate(['/register']);
  }

  goToPrivacyPolicy() {
    this.router.navigate(['/privacy-policy']);
  }

  goToTermsOfService() {
    this.router.navigate(['/terms-of-service']);
  }

  goToSocilMedia(app) {
    if (app == 'instagram') {
      window.open(environment.instagramUrl, '_blank', 'noopener,noreferrer');
    }
    if (app == 'facebook') {
      window.open(environment.facebookUrl, '_blank', 'noopener,noreferrer');
    }
    if (app == 'tiktok') {
      window.open(environment.tiktokUrl, '_blank', 'noopener,noreferrer');
    }
  }
}
